import { actions, selectors } from 'data'
import { ModalNameType } from 'data/App/types'
import { connect, ConnectedProps } from 'react-redux'

import ResetPassword from './template'

type OwnPropsType = {
  readonly modalName?: ModalNameType
}

export type Props = OwnPropsType & ConnectedProps<typeof connector>

const mapStateToProps = (state) => ({
  fieldLoading: selectors.forgotPassword.getFieldLoading(state),
  isLoading: selectors.forgotPassword.isLoading(state)
})

const mapDispatchToProps = (dispatch) => ({
  handleSubmit: () => {
    dispatch(actions.forgotPassword.submitReset())
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(ResetPassword)
